import React from 'react';
import { Link } from 'react-router-dom';
import styles from './VerificationPopup.module.css';

interface VerificationPopupProps {
  email: string;
  onClose: () => void;
}

const VerificationPopup: React.FC<VerificationPopupProps> = ({ email, onClose }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <img src="/BodyOwn_Logo.png" alt="BodyOwn Logo" className={styles.logo} />
        <h2 className={styles.title}>Verify Your Email</h2>
        <p className={styles.message}>
          A verification email has been sent to <strong>{email}</strong>.
        </p>
        <p className={styles.instructions}>
          Please click the link in the email to verify your account. Once verified, you can log in.
        </p>
        <p className={styles.spamNote}>
          If you don't see the email, please check your spam folder.
        </p>
        <div className={styles.actions}>
          <Link to="/login" className={styles.loginButton} onClick={onClose}>
            Go to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerificationPopup;
